import { render } from "./device-login.vue?vue&type=template&id=cc41f55c&ts=true"
import script from "./device-login.vue?vue&type=script&lang=ts"
export * from "./device-login.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__